// Grid Column Visibility Configuration
export const trailMaterialsGridColumns = {
    'Material ID': true,
    'Pollination ID': false,
    'Barcode': false,
    'Admin Code': false,
    'Greenhouse Location': true,
    'Pollination Type': false,
    'Type/Segment': false,    
    'HRVMD': false,
    'Special Requisites': false,
    'Processing Priority': false,
    'Subplot ID': true,
    'Harvests': true,
    'Generation Code': false,
    'Stage Code': false,
    'Required Seed Weight (g)': true,
    'Required Seed Count': true,
    'Required Fruit Count': true,
    'Seed Weight (g)': true,
    'Seed Count': true,
    'Fruit Count': true,
    'Fruit Weight (g)': true,
    'Bags': true,
    'Registered Containers': true,
    'Goal Achieved %': false,
    'Status': true,
    'Remarks': true,
    'Actions': true
};

// Local Storage Keys
export const LOCAL_STORAGE_KEYS = {
    TRIAL_FILTER: 'trialFilterData',
    TRAIL_MATERIALS_COLUMN_VISIBILITY: 'trailMaterialsColumnVisibility',
    TRAIL_MATERIALS_COLUMN_ORDER: 'trailMaterialsColumnOrder'
} as const;

export const DEFAULT_PROCESSING_PRIORITIES = [
    { id: 'High', value: 'High' },
    { id: 'Medium', value: 'Medium' },
    { id: 'Low', value: 'Low' },
] as const;
// Legacy export for backward compatibility
export const LOCAL_STORAGE_KEY = LOCAL_STORAGE_KEYS.TRIAL_FILTER;

// Form Field Dimensions
export const FIELD_HEIGHT = 40;
export const FIELD_WIDTHS = {
    xs: 150,
    sm: 250,
    md: 280
} as const;

// Pagination Configuration
export const PAGE_SIZE_OPTIONS = [20, 50, 100, 500] as const;
export const DEFAULT_PAGE_SIZE = 50;
export const FILTER_PAGE_SIZE = 100;
// Larger default used by drilldown grids (post-season Trial/SPLot drilldown, in-season Ready for Harvest)
export const DRILLDOWN_DEFAULT_PAGE_SIZE = 100;

export const TRAIL_MATERIALS_PINNED_LEFT_COLUMNS = ['__check__', '__expand__', 'mat_id', 'harvest_count'] as const;

// Layout Dimensions
export const BUTTON_HEIGHT = 40;
export const BUTTON_PADDING = 1.5;
export const BUTTON_MARGIN = 2;

export const ProposeIcon = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.333 1.3335L13.9997 4.00016L11.333 6.66683" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2 7.33333V6.66667C2 5.95942 2.28095 5.28115 2.78105 4.78105C3.28115 4.28095 3.95942 4 4.66667 4H14" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.66667 14.6668L2 12.0002L4.66667 9.3335" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14 8.6665V9.33317C14 10.0404 13.719 10.7187 13.219 11.2188C12.7189 11.7189 12.0406 11.9998 11.3333 11.9998H2" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

export const FIELD_TO_ERROR_CODE = {
    crop: "Crop",
    from_date: "Start Date",
    to_date: "Start Date",
    trial_id: "Trial ID",
    local_code: "Local Code",
    sector: "Sector",
    matid_completion: "MatID Completion %",
    trial_filter_name: "Filter Name"
} as const;

/* In Season Trial material  */

// Local Storage Keys
export const LOCAL_STORAGE_KEYS_INSEASON = {
    TRIAL_FILTER: 'trialInSeaFilterData',
    TRAIL_MATERIALS_COLUMN_VISIBILITY: 'trailInSeaMaterialsColumnVisibility',
    TRAIL_MATERIALS_COLUMN_ORDER: 'trailInSeaMaterialsColumnOrder'
} as const;

export const LOCAL_STORAGE_KEY_INSEASON = LOCAL_STORAGE_KEYS.TRIAL_FILTER;

export const trailInSeaMaterialsGridColumns = {
    'Material ID': true,
    // 'Trial ID': true,
    'Greenhouse Location': true,
    'Pollination ID': false,
    'Admin Code': true,
    'Subplot ID': false,
    'HRVMD': true,
    'Pollination Type': true,
    'Barcode': false,
    'Generation Code': false,
    'Stage Code': false,
    'Processing Priority': true,
    'Special Requisites': false,
    'Required Seed Weight(g)': true,
    'Required Fruit Count': true,
    'Required Seed Count': false,
    'Description': true,
    'Actions': true
};